import { DashboardKpis } from 'dtos/analytics/dashboard.dto';
import { CoverageReport } from 'dtos/analytics/coverage.dto';
import { apiClient } from 'services/api-client';

export class DashboardService {
  static async getSummary(orgId: string, storeId: string, period: '7d' | '30d'): Promise<DashboardKpis> {
    const response = await apiClient.get<DashboardKpis>(`/orgs/${orgId}/stores/${storeId}/dashboard?period=${period}`);
    return response.data;
  }

  static async getCoverage(orgId: string, storeId: string, period: '7d' | '30d'): Promise<CoverageReport> {
    const response = await apiClient.get<CoverageReport>(`/orgs/${orgId}/stores/${storeId}/analytics/coverage?period=${period}`);
    return response.data;
  }
}

